import Reflux from 'reflux';
import { AppActions, KlarnaActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

const KlarnaStore = Reflux.createStore({
  listenables: [KlarnaActions],
  data: {
    email: null,
    phone: null,
    firstName: null,
    lastName: null,
    street: null,
    zip: null,
    city: null,
    country: null,
    ssn: null,
    loading: false
  },
  getInitialState() {
    return this.data;
  },
  paymentStarted(data) {
    console.log(data);
  },
  change(props) {
    this.data = {
      ...this.data,
      ...props
    };
    this.trigger(this.data);
  },
  getAddressesBySsn(ssn) {
    this.data = {
      ...this.data,
      loading: true
    };
    this.trigger(this.data);
    return SteelCompass.request('payment', 'getAddressesBySsn', { ssn }).then(
      address => {
        KlarnaActions.getAddressesBySsnComplete(address[0]);
      },
      error => {
        this.data = {
          ...this.data,
          loading: false
        };
        this.trigger(this.data);
        AppActions.genericError(error);
      }
    );
  },
  getAddressesBySsnComplete(address) {
    this.data = {
      ...this.data,
      ...address,
      loading: false
    };
    this.trigger(this.data);
  }
});

export default KlarnaStore;



// WEBPACK FOOTER //
// ./src/js/stores/Klarna.js